import React, { useEffect, useState } from "react";
import { useStores } from "../../store";
import { Button } from "@radix-ui/themes";

export default function SubmitButton({
  onClick,
  loading,
  transcript,
  speaking,
  initialCount = 50,
  isUserSpeaking = false, // this is to check if the user is speaking or not in mobile view
}) {
  const [count, setcount] = useState(initialCount);
  const { PopupStore, InterviewStore } = useStores();

  const [stopCountdown, setStopCountdown] = useState(false);

  // i want a count down timer here from 10 to 0 for every 1 sec
  // i want to disable the button after 10 sec

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        !stopCountdown &&
        !PopupStore.compiler &&
        !PopupStore.issueReportPopup &&
        !InterviewStore.UserMSGError &&
        count > 0 &&
        !loading &&
        !speaking
      )
        setcount(count - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [count, stopCountdown, PopupStore.compiler, PopupStore.issueReportPopup]);

  useEffect(() => {
    console.log("count, stopCountdown", count, stopCountdown);
    if (count === 0) {
      onClick();
    }
  }, [count]);

  let oldTranscript = "";
  let timer1;

  // set the count to 10 when the transcript changes
  useEffect(() => {
    console.log("transcript", transcript);
    // console.log("speaking, loading", speaking, loading);
    // console.log("loading", loading);
    // console.log("speaking", speaking);

    if (loading || speaking || isUserSpeaking) {
      setcount(8);
      setStopCountdown(true);

      return clearTimeout(timer1);
    } else if (transcript !== oldTranscript) {
      clearTimeout(timer1);
      // check difference between old and new transcript
      setcount(8);
      setStopCountdown(true);
      oldTranscript = transcript;
      timer1 = setTimeout(() => {
        setStopCountdown(false);
      }, 3000);
      return;
    }

    setTimeout(() => {
      setStopCountdown(false);
    }, 2000);
  }, [transcript, loading, speaking]);

  useEffect(() => {
    // console.log("stopCountdown", stopCountdown);
  }, [stopCountdown]);

  return (
    <Button
      onMouseEnter={() => setStopCountdown(true)}
      onMouseLeave={() => {
        console.log("mouse leave");
        if (speaking || loading) return;
        setStopCountdown(false);
      }}
      onClick={onClick}
      id="submit-button"
      size={{ initial: "2", md: "4", lg: "4" }}
      variant={loading ? "soft" : "solid"}
      color={
        loading
          ? "gray"
          : count < 8 && count > 3
          ? "yellow"
          : count < 4
          ? "red"
          : "#FF6B00"
      }
      disabled={loading || speaking}
      className="mt-2 w-[60%] ml-2 md:text-sm lg:text-lg text-xs"
    >
      {loading ? "Loading..." : count < 8 ? `Auto Submit ${count}` : `Submit`}
    </Button>
  );
}
